module.exports = __webpack_public_path__ + "fonts/926a08f.ttf";